<div *tdWbIfNoFeature="'universalSearch'"
     class="td-wb-search-modal__header-container">
  <td-wb-modal-header class="td-wb-search-modal__header">
    <td-wb-modal-header-title class="td-wb-search-modal__header-title"
                              modalTitle="tdWb.search.SEARCH" />
    <td-wb-modal-header-buttons class="td-wb-search-modal__header-buttons">
      <td-wb-modal-close-button class="td-wb-search-modal__header-close"
                                buttonBackground="clear-grey"
                                [autoFocus]="false" />
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>
</div>
<div *tdWbIfFeature="'universalSearch'">
  <div class="td-wb-site-wide-search__header-container">
    <div class="td-wb-search-modal__header-icon">
      <td-wb-icon iconId="logo--td"
                  size="29x26" />
    </div>
    <td-wb-modal-header class="td-wb-search-modal__new-header">
      <td-wb-modal-header-title class="td-wb-search-modal__new-header-title"
                                modalTitle="tdWb.search.SEARCH" />
    </td-wb-modal-header>
    <td-wb-modal-close-button buttonBackground="clear-grey"
                              [autoFocus]="false"
                              class="td-wb-search-modal__header-close td-wb-site-wide-search__close-icon" />
  </div>
  <div class="td-wb-site-wide-search__search-text">
    <span translate="tdWb.search.SEARCH_TEXT"></span>
  </div>
</div>

<td-wb-analytics-context analyticsContext="td-wb-search-modal" />

<td-wb-modal-panel [right]="false"
                   [left]="false"
                   class="td-wb-search-modal__container">
  <div *tdWbIfNoFeature="'universalSearch'"
       class="td-wb-search-modal__sticky-wrapper"
       [class.td-wb-search-modal__sticky-wrapper--sticky]="stickyState">
    <td-wb-form novalidate>
      <td-wb-form-row class="td-wb-search-form-row">
        <div class="td-wb-search-modal__section">
          <div id="td-wb-search-field-wrap-aria"
               class="td-wb-search-field td-wb-search-modal__content"
               [class.td-wb-search-field--invalid]="hasError(searchInput)">
            <span class="td-wb-search-field__wrap">
              <td-wb-input-group class="td-wb-search-input-group">
                <label class="td-wb-vh"
                       for="searchBar"
                       [translate]="'tdWb.search.PLACEHOLDER'">
                </label>
                <td-wb-input-group-field class="td-wb-search-input-group-field">
                  <td-wb-clear-field class="td-wb-search-field__wrap__clear-field">
                    <input tdWbInput
                           class="td-wb-search-field__input"
                           type="text"
                           autocomplete="off"
                           id="searchBar"
                           name="searchVideoLessonsOrHelpTopics"
                           tdWbInputAriaDescribedBy="td-wb-aria-site-search-instructions"
                           [tdWbFocus]="true"
                           [pattern]="allowableCharactersRegex"
                           [tdWbInputValidator]="createSearchValidator()"
                           [(ngModel)]="searchInput"
                           (ngModelChange)="inputChange($event)"
                           [placeholder]="'tdWb.search.PLACEHOLDER' | tdWbTranslate"/>
                    </td-wb-clear-field>
                    <td-wb-input-errors errorKeyNamespace="tdWb.search.inputErrors"
                                        [multiLine]="true"
                                        [multiLineSpaceReserve]="false"
                                        [errorKeyDisplayBeforeSubmit]="['pattern', 'special']" />
                  </td-wb-input-group-field>
                </td-wb-input-group>

                <span id="td-wb-aria-site-search-instructions"
                      class="td-wb-vh"
                      [translate]="'tdWb.search.INSTRUCTIONS_ARIA'"></span>
                <button tdWbIconButton
                        tdWbIconButtonSize="extra-small"
                        tdWbIconButtonShape="circle"
                        id="searchButton"
                        type="button"
                        [attr.aria-label]="'tdWb.search.SEARCH' | tdWbTranslate"
                        (click)="onSearchButtonClicked()">
                  <td-wb-icon class="td-wb-search-field__search-icon"
                              size="16"
                              iconId="search" />
                </button>
              </span>
          </div>
        </div>
      </td-wb-form-row>
    </td-wb-form>
  </div>
  <td-wb-form *tdWbIfFeature="'universalSearch'"
              novalidate>
    <td-wb-form-row class="td-wb-search-form-row">
      <div class="td-wb-site-wide-search__section">
        <div id="td-wb-search-field-wrap-aria"
             class="td-wb-search-field td-wb-site-wide-search__content"
             [class.td-wb-search-field--invalid]="hasError(searchInput)">
            <span class="td-wb-site-wide-search__wrap">
              <td-wb-input-group class="td-wb-search-input-group">
                <label class="td-wb-vh"
                       for="searchBar"
                       [translate]="'tdWb.search.PLACEHOLDER_FEATURE_ON'"></label>
                <td-wb-input-group-field class="td-wb-search-input-group-field">
                  <td-wb-clear-field class="td-wb-search-field__wrap__clear-field">
                    <input #searchInputField
                           tdWbInput
                           class="td-wb-search-field__input"
                           type="text"
                           autocomplete="off"
                           id="searchBar"
                           name="searchVideoLessonsOrHelpTopics"
                           tdWbInputAriaDescribedBy="td-wb-aria-site-search-instructions"
                           [tdWbFocus]="true"
                           [pattern]="allowableCharactersRegex"
                           [tdWbInputValidator]="createSearchValidator()"
                           [(ngModel)]="searchInput"
                           (ngModelChange)="inputChange($event)"
                           (keydown.enter)="searchValueExists()"
                           [placeholder]="'tdWb.search.PLACEHOLDER_FEATURE_ON' | tdWbTranslate"/>
                    </td-wb-clear-field>
                    <td-wb-input-errors errorKeyNamespace="tdWb.search.inputErrorsFeatureON"
                                        [multiLine]="true"
                                        [multiLineSpaceReserve]="false"
                                        [errorKeyDisplayBeforeSubmit]="['pattern', 'special']" />
                  </td-wb-input-group-field>
                </td-wb-input-group>
<span class="td-wb-search-field__search-button">
                <span id="td-wb-aria-site-search-instructions"
                      class="td-wb-vh"
                      [translate]="'tdWb.search.INSTRUCTIONS_ARIA'"></span>
                <button tdWbIconButton
                        tdWbIconButtonShape="circle"
                        tdWbIconButtonSize="extra-small" id="searchButton"

                        [attr.aria-label]="'tdWb.search.SEARCH' | tdWbTranslate"
                        (click)="onSearchButtonClicked()">
                  <td-wb-icon class="td-wb-search-field__search-icon"
                              size="16"
                              iconId="search" />
                </button>
              </span>
        </span>
        </div>
      </div>
    </td-wb-form-row>
  </td-wb-form>
  <td-wb-sticky-observer *tdWbIfNoFeature="'universalSearch'"
                         [offset]="0"
                         (stateChange)="stickyStateChange($event)" />
  <div *tdWbIfNoFeature="'universalSearch'"
       class="td-wb-search-modal__section">
    @if (displayResults()) {
      <div class="td-wb-search-modal__content td-wb-search-modal__results">
        @if (isLoading()) {
          <td-wb-detailed-loading-indicator class="td-wb-search-modal__loading-indicator" />
        }
        @if (!isLoading()) {
          <div>
            <!-- Show help first if it is first in the categoryOrder array, otherwise education -->
            <ng-container *ngTemplateOutlet="isHelpDisplayedFirst() ? helpSection : educationSection" />
            <!-- Show help here if it is not first in the categoryOrder array, otherwise education -->
            <ng-container *ngTemplateOutlet="!isHelpDisplayedFirst() ? helpSection : educationSection" />
            <!-- No Results Found -->
            @if (displayNoResultsFound()) {
              <div
                class="td-wb-search-results-no-results-found">
                <div>
                  <h2 class="td-wb-search-results-title"
                      translate="tdWb.search.NO_RESULTS_HEADER"></h2>
                  <td-wb-divider class="td-wb-search-modal__divider" />
                  <div class="td-wb-search-result">
                        <span aria-live="polite"
                              aria-atomic="true"
                              class="td-wb-search-result__content">
                          <span translate="tdWb.search.NO_RESULTS_BODY"></span>
                        </span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- Promo links when nothing has been entered into search input -->
    @if (!displayResults()) {
      <div class="td-wb-search-modal__content td-wb-search-modal__results">
        <h2 class="td-wb-search-results-title"
            translate="tdWb.search.HELPFUL_RESOURCES"></h2>
        <td-wb-divider class="td-wb-search-modal__divider" />
        <div class="td-wb-search__promo-link">
          <a class="td-wb-link"
             tdWbHref="link_search_promo1"
             target="_blank"
             rel="noopener">
            <span translate="tdWb.search.links.PROMO1"></span>
            <td-wb-icon class="td-wb-search__external-link-icon"
                        iconId="new-page"
                        [inline]="true"
                        size="12" />
          </a>
        </div>
        <div class="td-wb-search__promo-link">
          <a class="td-wb-link"
             tdWbHref="link_search_promo2"
             target="_blank"
             rel="noopener">
            <span translate="tdWb.search.links.PROMO2"></span>
            <td-wb-icon class="td-wb-search__external-link-icon"
                        iconId="new-page"
                        [inline]="true"
                        size="12" />
          </a>
        </div>
        <div class="td-wb-search__promo-link">
          <a class="td-wb-link"
             tdWbHref="link_search_promo3"
             target="_blank"
             rel="noopener">
            <span translate="tdWb.search.links.PROMO3"></span>
            <td-wb-icon class="td-wb-search__external-link-icon"
                        iconId="new-page"
                        [inline]="true"
                        size="12" />
          </a>
        </div>
      </div>
    }
  </div>
  <div *tdWbIfFeature="'universalSearch'"
       class="td-wb-site-wide-search__empty-section">
    @if (!displayResults()) {
      <div
        class="td-wb-site-wide-search__blank-cards ">
        @if (recentSearchResults().length > 0) {
          <div
            class="td-wb-site-wide-search__card">
            <div class="td-wb-site-wide-search__header">
              <h2 class="td-wb-site-wide-search__title">
                    <span class="td-wb-site-wide-search__header-title"
                          translate="tdWb.search.RECENT_SEARCHES"></span>
              </h2>
            </div>
            <div tdWbFocusTracker>
              @for (recentSearch of recentSearchResults(); track recentSearch; let i = $index) {
                <div>
                  <div class="td-wb-site-wide-search__recent-search-results">
                    @if (showRecentSearchSymbol(recentSearch)) {
                      <div class="td-wb-site-wide-search__recent-search-results__container">
                        <div class="td-wb-site-wide-search__quotes td-wb-site-wide-search__quotes--recent-search">
                          <button tdWbButton
                                  tdWbButtonType="icon"
                                  [id]="'td-wb-site-wide-search-symbol-icon-'+ i"
                                  [attr.aria-label]="'tdWb.search.CLICK_TO_EXPAND' | tdWbTranslate"
                                  [attr.aria-describedby]="'td-wb-site-wide-search-symbol-text-'+ i"
                                  [attr.aria-expanded]="isRowExpanded(i)"
                                  (click)="toggleExpandRecentSearchRow(i)"
                                  (keydown.enter)="toggleExpandRecentSearchRow(i)">
                            <td-wb-expand-icon [expanded]="isRowExpanded(i)" />
                          </button>
                          <td-wb-ticker-symbol [id]="'td-wb-site-wide-search-symbol-text-'+ i"
                            class="td-wb-site-wide-search__symbol"
                            [market]="recentSearch.market"
                            [symbolType]="recentSearch.symbolType"
                            [tickerSymbol]="recentSearch.searchText"
                            [description]="recentSearch.description"
                            [singleLine]="true"
                            [shortDescription]="true"
                            (onToggle)="toggleExpandRecentSearchRow(i)" />
                        </div>
                      </div>
                    } @else {
                      <div class="td-wb-site-wide-search__recent-search-plain-text">
                        <a role="button"
                           href=""
                           [tdWbFocusTrackerItem]="recentSearch.searchText"
                           class="td-wb-link td-wb-site-wide-search__recent-search"
                           (keydown.enter)="setRecentSearch(recentSearch.searchText)"
                           (click)="setRecentSearch(recentSearch.searchText)">
                          <span [attr.id]="'td-wb-aria-recent-search-text-' + i"
                                [innerText]="recentSearch.searchText"></span>
                        </a>
                      </div>
                    }
                    <button [id]="'td-wb-site-wide-search-clear-' + i"
                            tdWbIconButton
                            tdWbIconButtonSize="extra-small"
                            tdWbIconButtonBackground="all-grey"
                            class="td-wb-site-wide-search__recent-search-icon"
                            [attr.aria-label]="'tdWb.search.CLEAR_ARIA' | tdWbTranslate"
                            [attr.aria-describedby]="'td-wb-aria-recent-search-text-' + i"
                            (click)="clearRecentSearches(recentSearch)">
                      <td-wb-icon iconId="close--small" size="12" />
                    </button>
                  </div>
                  @if (isRowExpanded(i)) {
                    <div>
                      <td-wb-markets-detailed-quote [symbol]="getSymbolFromRecentSearch(recentSearch)"
                                                    [includeDrip]="true"
                                                    [inactivateBuySell]="isBuySellDisabled(recentSearch)" />
                    </div>
                  }
                  @if (!isRowExpanded(i)) {
                    <td-wb-divider />
                  }
                </div>
              }
              <div
                class="td-wb-site-wide-search__clear-recent-searches">
                <button class="td-wb-site-wide-search__clear-recent-searches--results"
                        id="td-wb-site-wide-search-recent-search-clear-all"
                        tdWbButton
                        tdWbButtonType="secondary"
                        (click)="clearRecentSearches()">
                  <span translate="tdWb.search.CLEAR_RECENT_SEARCHES"></span>
                </button>
              </div>
            </div>
          </div>
        }
        <div class="td-wb-site-wide-search__card">
          <div class="td-wb-site-wide-search__header">
            <h2 class="td-wb-site-wide-search__title">
                  <span class="td-wb-site-wide-search__header-title"
                        translate="tdWb.search.HELPFUL_RESOURCES"></span>
            </h2>
          </div>
          <div class="td-wb-site-wide-search__blank-search-results td-wb-site-wide-search__promo-link">
            <a class="td-wb-link"
               tdWbHref="link_search_promo1"
               target="_blank"
               rel="noopener"
               [tdWbFocus]="hasFocus()"
               [attr.tabindex]="hasFocus() ? 0 : -1">
              <span translate="tdWb.search.links.PROMO1"></span>
              <td-wb-icon class="td-wb-search__external-link-icon"
                          iconId="new-page"
                          [inline]="true"
                          size="12" />
            </a>
          </div>
          <td-wb-divider />
          <div class="td-wb-site-wide-search__blank-search-results td-wb-site-wide-search__promo-link">
            <a class="td-wb-link"
               tdWbHref="link_search_promo2"
               target="_blank"
               rel="noopener">
              <span translate="tdWb.search.links.PROMO2"></span>
              <td-wb-icon class="td-wb-search__external-link-icon"
                          iconId="new-page"
                          [inline]="true"
                          size="12" />
            </a>
          </div>
          <td-wb-divider />
          <div class="td-wb-site-wide-search__blank-search-results td-wb-site-wide-search__promo-link">
            <a class="td-wb-link"
               tdWbHref="link_search_promo3"
               target="_blank"
               rel="noopener">
              <span translate="tdWb.search.links.PROMO3"></span>
              <td-wb-icon class="td-wb-search__external-link-icon"
                          iconId="new-page"
                          [inline]="true"
                          size="12" />
            </a>
          </div>
          <td-wb-divider />
        </div>
      </div>
    }
    @if (displayResults()) {
      <div class="td-wb-site-wide-search__blank-cards">
        @if (isLoading()) {
          <td-wb-detailed-loading-indicator class="td-wb-search-modal__loading-indicator" />
        }
        @if (!isLoading()) {
          <div class="td-wb-site-wide-search__card">
            <ng-container *ngTemplateOutlet="symbolSection" />
            <ng-container *ngTemplateOutlet="educationSectionWithUniversalSearch" />
            <ng-container *ngTemplateOutlet="helpSectionWithUniversalSearch" />
            <!-- No Results Found -->
            @if (displayNoResultsFound()) {
              <div class="td-wb-search-results-no-results-found">
                <div class="td-wb-site-wide-search__header">
                  <h2 class="td-wb-site-wide-search__title">
                        <span class="td-wb-site-wide-search__header-title"
                              translate="tdWb.search.NO_RESULTS_HEADER_FEATURE_ON"></span>
                  </h2>
                </div>
                <td-wb-divider class="td-wb-search-modal__divider" />
                <div class="td-wb-site-wide-search__no-results--content">
                      <span aria-live="polite"
                            aria-atomic="true">
                        <span translate="tdWb.search.NO_RESULTS_BODY_FEATURE_ON"></span>
                      </span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

</td-wb-modal-panel>

<ng-template #educationSection>
  @if (displayEducationResults()) {
    <div class="td-wb-search-results-education">
      <h2 class="td-wb-search-results-title"
          translate="tdWb.search.VIDEO_LESSONS"></h2>
      <td-wb-divider class="td-wb-search-modal__divider" />
      @for (educationItem of (searchResult()?.education ?? []); track educationItem; let j = $index) {
        <div class="td-wb-search-result">
          <div class="td-wb-search-result__title">
            <a class="td-wb-search-result__link"
               [attr.aria-describedby]="'td-wb-aria-learn-snippet-content-' + j"
               [tdWbHref]="educationItem.url"
               [innerHtml]="educationItem.title"></a>
          </div>
          <div [id]="'td-wb-aria-learn-snippet-content-' + j"
               class="td-wb-search-result__content">
            @for (content of educationItem.content; track content; let i = $index) {
              <span>
                    @if (displayTextSnippet(i)) {
                      <span
                        [innerHtml]="content + ' ... '"></span>
                    }
                  </span>
            }
          </div>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #helpSection>
  @if (displayHelpResults()) {
    <div class="td-wb-search-results-help">
      <h2 class="td-wb-search-results-title"
          translate="tdWb.search.HELP_ARTICLES"></h2>
      <td-wb-divider class="td-wb-search-modal__divider" />
      @for (helpItem of (searchResult()?.help ?? []); track helpItem; let j = $index) {
        <div class="td-wb-search-result">
          <div class="td-wb-search-result__title">
            <a class="td-wb-search-result__link"
               [attr.aria-describedby]="'td-wb-aria-help-article-snippet-content-' + j"
               [tdWbHref]="helpItem.url"
               tdWbModalClose
               [innerHtml]="helpItem.title"></a>
          </div>
          <div [id]="'td-wb-aria-help-article-snippet-content-' + j"
               class="td-wb-search-result__content">
            @for (content of helpItem.content; track content; let i = $index) {
              <span>
                    @if (displayTextSnippet(i)) {
                      <span
                        [innerHtml]="content + ' ... '"></span>
                    }
                  </span>
            }
          </div>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #symbolSection>
  @if (displaySymbolResults()) {
    <div class="td-wb-search-results-symbol">
      <div class="td-wb-site-wide-search__header">
        <h2 class="td-wb-site-wide-search__title">
              <span class="td-wb-site-wide-search__header-title"
                    translate="tdWb.search.SYMBOLS"></span>
        </h2>
      </div>
      @for (symbol of (searchResult()?.symbol ?? []); track symbol; let j = $index) {
        <div>
          <div class="td-wb-site-wide-search__quotes">
            <button tdWbButton
                    tdWbButtonType="icon"
                    [id]="'td-wb-site-wide-search-symbol-icon-'+ j"
                    [attr.aria-label]="'tdWb.search.CLICK_TO_EXPAND' | tdWbTranslate"
                    [attr.aria-describedby]="'td-wb-site-wide-search-symbol-text-'+ j"
                    [attr.aria-expanded]="isRowExpanded(j)"
                    (click)="toggleExpandRow(j)"
                    (keydown.enter)="toggleExpandRow(j)">
              <td-wb-expand-icon [expanded]="isRowExpanded(j)" />
            </button>
            <td-wb-ticker-symbol [id]="'td-wb-site-wide-search-symbol-text-'+ j"
              class="td-wb-site-wide-search__symbol"
              [market]="symbol.marketType"
              [symbolType]="symbol.symbolType"
              [tickerSymbol]="symbol.symbol"
              [description]="symbol.description"
              [singleLine]="true"
              [shortDescription]="true"
              (onToggle)="toggleExpandRow(j)" />
          </div>
          @if (isRowExpanded(j)) {
            <div>
              <td-wb-markets-detailed-quote [symbol]="getSymbol(symbol)"
                                            [includeDrip]="true"
                                            [inactivateBuySell]="isBuySellDisabled(symbol)" />
            </div>
          }
          @if (!isRowExpanded(j)) {
            <td-wb-divider />
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #helpSectionWithUniversalSearch>
  @if (displayHelpResults()) {
    <div
      class="td-wb-search-results-help">
      <div class="td-wb-site-wide-search__header">
        <h2 class="td-wb-site-wide-search__title">
              <span class="td-wb-site-wide-search__header-title"
                    translate="tdWb.search.HELP_ARTICLES"></span>
        </h2>
      </div>
      @for (helpItem of (searchResult()?.help ?? []); track helpItem; let j = $index) {
        <div class="td-wb-site-wide-search__result">
          <div class="td-wb-site-wide-search__help-education-section">
            <div class="td-wb-site-wide-search__help-education">
              <div class="td-wb-site-wide-search__help-education--title">
                <a [id]="'td-wb-site-wide-search-help-content-'+ j"
                   class="td-wb-search-result__link"
                   [attr.aria-describedby]="'td-wb-aria-help-article-snippet-content-' + j"
                   (onNavigate)="setRecentSearchesAndNavigate($event, j )"
                   [tdWbHref]="helpItem.url"
                   tdWbModalClose
                   [innerHtml]="helpItem.title">
                </a>
              </div>
              <div [id]="'td-wb-aria-help-article-snippet-content-' + j"
                   class="td-wb-site-wide-search__help-education--content">
                @for (content of helpItem.content; track content; let i = $index) {
                  <span>
                        @if (displayTextSnippet(i)) {
                          <span
                            [innerHtml]="content + ' ... '"></span>
                        }
                      </span>
                }
              </div>
            </div>
            <td-wb-icon class="td-wb-site-wide-search__help-education-icon"
                        iconId="caret-right--small"
                        [inline]="true" />
          </div>
          <td-wb-divider class="td-wb-search-modal__divider" />
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #educationSectionWithUniversalSearch>
  @if (displayEducationResults()) {
    <div
      class="td-wb-search-results-education">
      <div class="td-wb-site-wide-search__header">
        <h2 class="td-wb-site-wide-search__title">
              <span class="td-wb-site-wide-search__header-title"
                    translate="tdWb.search.VIDEO_LESSONS"></span>
        </h2>
      </div>
      @for (educationItem of (searchResult()?.education ?? []); track educationItem; let j = $index) {
        <div class="td-wb-site-wide-search__result">
          <div class="td-wb-site-wide-search__help-education-section">
            <div class="td-wb-site-wide-search__help-education">
              <div class="td-wb-site-wide-search__help-education--title">
                <a [id]="'td-wb-site-wide-search-education-content-'+ j"
                   class="td-wb-search-result__link"
                   [attr.aria-describedby]="'td-wb-aria-learn-snippet-content-' + j"
                   (onNavigate)="setRecentSearchesAndNavigate($event, j)"
                   [tdWbHref]="educationItem.url"
                   [innerHtml]="educationItem.title"
                   [tdWbHrefAsync]="true">
                </a>
              </div>
              <div [id]="'td-wb-aria-learn-snippet-content-' + j"
                   class="td-wb-site-wide-search__help-education--content">
                @for (content of educationItem.content; track content; let i = $index) {
                  <span>
                        @if (displayTextSnippet(i)) {
                          <span
                            [innerHtml]="content + ' ... '"></span>
                        }
                      </span>
                }
              </div>
            </div>
            <td-wb-icon class="td-wb-site-wide-search__help-education-icon"
                        iconId="caret-right--small"
                        [inline]="true" />
          </div>
          <td-wb-divider class="td-wb-search-modal__divider" />
        </div>
      }
    </div>
  }
</ng-template>
